import React from 'react';
import { MeetingRoom } from '@material-ui/icons';
import { Box, ListItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { OrderCard, MilestoneTitle, MilestoneDetail, ListItemIconDense } from '../style';
import { milestoneStateToText } from '../utils';
import { getInitials, getFullName } from '../../../../../utils';
import { TableIcon } from '../../../../../ui-kit';
import { OrderCreated, MovedCompletely, CanceledCompletely, isCanceledCompletely, OrderClosed } from '../../../../../types';
import { useDateTimeService } from '../../../../../utils/hooks/dateTimeService';
import { useUser } from '../../../../../utils/hooks/auth';

const TimelineMilestone: React.FC<OrderCreated | MovedCompletely | CanceledCompletely | OrderClosed> = props => {
    const { timestamp, eventType, details: { changedBy: { account } } } = props;
    const { t } = useTranslation();
    const { dateTimeService } = useDateTimeService();
    const { user } = useUser();
    
    const openedTime = dateTimeService.localizeTime(timestamp, user.cultureCode);
    const milestoneTitle = milestoneStateToText[eventType];

    return (
        <OrderCard state={eventType}>
            <Box display='flex' width='40%' flexDirection='column'>
                <ListItem dense>
                    <MilestoneTitle>
                        {t(...milestoneTitle)}
                    </MilestoneTitle>
                </ListItem>
                <ListItem dense>
                    <ListItemAvatar>
                        <Avatar>
                            {getInitials(account)}
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText disableTypography primary={<MilestoneDetail>{getFullName(account)}</MilestoneDetail>} />
                </ListItem>
            </Box>
            <Box display='flex' width='30%' flexDirection='column'>
                <ListItem dense>
                    <MilestoneTitle>
                        {t('At time')}
                    </MilestoneTitle>
                </ListItem>
                <ListItem dense>
                    <ListItemIconDense orderStatus={eventType}>
                        <MeetingRoom fontSize='large' />
                    </ListItemIconDense>
                    <ListItemText disableTypography primary={<MilestoneDetail>{openedTime}</MilestoneDetail>} />
                </ListItem>
            </Box>
            <Box display='flex' width='30%' flexDirection='column'>
                {isCanceledCompletely(props)
                        ? (
                            <>
                                <ListItem dense>
                                    <MilestoneTitle>
                                        Reason
                                    </MilestoneTitle>
                                </ListItem>
                                <MilestoneDetail>{props.details.reason}</MilestoneDetail>
                            </>
                        )
                        : props.details.place && (
                            <>
                                <ListItem dense>
                                    <MilestoneTitle>
                                        {t('On Table')}
                                    </MilestoneTitle>
                                </ListItem>
                                <ListItem dense>
                                    <ListItemIconDense orderStatus={eventType}>
                                        <TableIcon fontSize='large' />
                                    </ListItemIconDense>
                                    <MilestoneDetail>{props.details.place.name}</MilestoneDetail>
                                </ListItem>
                            </>
                    )}
            </Box>
        </OrderCard>
    );
};

export default TimelineMilestone;
